import { render, staticRenderFns } from "./CDSSPagesTest.vue?vue&type=template&id=11517883&scoped=true&"
import script from "./CDSSPagesTest.vue?vue&type=script&lang=js&"
export * from "./CDSSPagesTest.vue?vue&type=script&lang=js&"
import style0 from "./CDSSPagesTest.vue?vue&type=style&index=0&id=11517883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11517883",
  null
  
)

export default component.exports